const StorageHelper = {
    // 1 haftalık süre (milisaniye cinsinden),  7 * 24 * 60 * 60 * 1000
    EXPIRY_TIME: 604800000,
    setWithExpiry(key, value) {
        const item = {
            value: value,
            timestamp: new Date().getTime(),
        };
        localStorage.setItem(key, JSON.stringify(item));
    },
    getWithExpiry(key) {
        const itemStr = localStorage.getItem(key);
        if (!itemStr) return null;

        const item = JSON.parse(itemStr);
        const now = new Date().getTime();

        if (now - item.timestamp > this.EXPIRY_TIME) {
            localStorage.removeItem(key);
            return null;
        }
        return item.value;
    },
};

class ProductListManager {
    constructor() {
        this.storageKey = "gtm-product-data";
    }

    saveProductListData(productId, collectionTitle) {
        let productList = StorageHelper.getWithExpiry(this.storageKey) || [];

        // Eğer aynı ID ile kayıt varsa güncelle, yoksa yeni ekle
        const existingIndex = productList.findIndex(
            (item) => Object.keys(item)[0] === productId
        );
        if (existingIndex !== -1) {
            productList[existingIndex] = { [productId]: collectionTitle };
        } else {
            productList.push({ [productId]: collectionTitle });
        }

        StorageHelper.setWithExpiry(this.storageKey, productList);
    }

    getCollectionTitleById(productId) {
        const productList = StorageHelper.getWithExpiry(this.storageKey) || [];
        const product = productList.find(
            (item) => Object.keys(item)[0] === productId
        );
        return product
            ? Object.values(product)[0]
            : "no list";
    }
}

const productListManager = new ProductListManager();

// Global scope'ta productListManager'ı erişilebilir yap
window.productListManager = productListManager;
